import React from "react";
import { Card, CardContent, Typography, Box, Input, Divider, Alert } from "@mui/joy";
import { TriangleRight } from "lucide-react";

import { SettingField } from "./EstimatingCommon";

interface ComplexityAdjustmentsProps {
    values: Record<string, any>;
    onChange: (key: string, value: any) => void;
}

export default function ComplexityAdjustments({ values, onChange }: ComplexityAdjustmentsProps) {
    return (
        <Card variant="soft" sx={{ border: "1px solid", borderColor: "divider" }}>
            <CardContent>
                <Typography level="title-sm" mb={2} startDecorator={<TriangleRight size={18} />}>
                    Complexity & Access Fees
                </Typography>

                <Alert size="sm" variant="soft" color="neutral" sx={{ mb: 2 }}>
                    Steep pitch, tear-off layers, and story height are read from Initial Inspection when the contract
                    is generated. Set per-SQ rates here only.
                </Alert>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mb: 2 }}>
                    <SettingField label="Steep charge 7/12 – 9/12" description="Per SQ when inspection pitch is in this range">
                        <Input
                            size="sm"
                            startDecorator="$"
                            value={values.EST_STEEP_RATE_7_9}
                            type="number"
                            onChange={(e) => onChange("EST_STEEP_RATE_7_9", e.target.value)}
                            sx={{ width: 100 }}
                        />
                    </SettingField>
                    <SettingField label="Steep charge 10/12 – 12/12">
                        <Input
                            size="sm"
                            startDecorator="$"
                            value={values.EST_STEEP_RATE_10_12}
                            type="number"
                            onChange={(e) => onChange("EST_STEEP_RATE_10_12", e.target.value)}
                            sx={{ width: 100 }}
                        />
                    </SettingField>
                    <SettingField label="Steep charge over 12/12">
                        <Input
                            size="sm"
                            startDecorator="$"
                            value={values.EST_STEEP_RATE_13_PLUS}
                            type="number"
                            onChange={(e) => onChange("EST_STEEP_RATE_13_PLUS", e.target.value)}
                            sx={{ width: 100 }}
                        />
                    </SettingField>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                    <SettingField
                        label="Extra tear-off layer rate"
                        description="Per SQ per layer above the first; layer count from inspection"
                    >
                        <Input
                            size="sm"
                            startDecorator="$"
                            type="number"
                            value={values.EST_EXTRA_LAYER_RATE}
                            onChange={(e) => onChange("EST_EXTRA_LAYER_RATE", e.target.value)}
                            sx={{ width: 100 }}
                        />
                    </SettingField>

                    <SettingField label="Trip charge">
                        <Input
                            size="sm"
                            startDecorator="$"
                            type="number"
                            value={values.EST_TRIP_CHARGE}
                            onChange={(e) => onChange("EST_TRIP_CHARGE", e.target.value)}
                            sx={{ width: 100 }}
                        />
                    </SettingField>

                    <SettingField label="No access fee">
                        <Input
                            size="sm"
                            startDecorator="$"
                            type="number"
                            value={values.EST_NO_ACCESS_FEE}
                            onChange={(e) => onChange("EST_NO_ACCESS_FEE", e.target.value)}
                            sx={{ width: 100 }}
                        />
                    </SettingField>
                </Box>
            </CardContent>
        </Card>
    );
}
